import React, { useState } from "react";
import Navbar from "../components/Nav.jsx";
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';
import { ToastContainer, toast } from 'react-toastify';
const queryString = require('query-string');

const UPDATE_PASSWORD = gql`
    mutation ClientForgotUpdatePassword($password: String! ){
      clientForgotUpdatePassword(password:$password)
    }
`;

const RecoverPassword =()=> {
    const [passwordError, setPasswordError] = useState(''); 
    const [conformPasswordError, setConformPasswordError] = useState('');
    const [Loading ,setLoading ] =useState(false);
    const passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,30})");

    const [password, setPassword] = useState(''); // '' is the initial state for password value
    const [confirmPassword, setConfirmPassword] = useState(''); // '' is the initial state for email value
    const [toggleMutation ] = useMutation(UPDATE_PASSWORD);
    const parse = queryString.parse(window.location.search);
    const token = parse.token;
    sessionStorage.setItem('access_token',token);

    const validate = () => {
        let passError = "";
        let conformPassError ="";
        if(password.length === 0 ){
            passError="Password is required";
          }else if(passwordRegex.test(password) !== true){
            passError="Password should contain 1 uppercase, 1 lower case, 1 special character, 1 number"
          }else{
            passError="";
          }
          if(password !== confirmPassword){
            conformPassError="Password and Confirm Password don't match";
          }else{
            conformPassError="";
          }
          if ( passError || conformPassError) {
            setPasswordError(passError);
            setConformPasswordError(conformPassError);
            return false;
          }else{
            return true;
          }
        }
      
      const recoverPassword =  () => {
        const isValid = validate();
        if (isValid) {
          setLoading(true);
          setPasswordError("");
          setConformPasswordError("");
          toggleMutation({
            variables: { password },
            optimisticResponse: true,
          }).then(res => {
            toast.success("Password Updated Successfully")
          }).then(() =>{
              window.sessionStorage.clear();
              window.location.href = `/`

          })
          .catch(error =>  
            toast.error(error.graphQLErrors[0].extensions.exception.response.error));
          setPassword('');
          setConfirmPassword('');
        }
        setLoading(false);
      };
      const nextKey = ()=> {
        document.getElementById('pass-value').focus();
      }
    return ( 
      <React.Fragment>
        <ToastContainer/> 
            <Navbar />
                <div className="row fill">
                <div className="col-lg-6 login-container">
                    <div>
                        <p className="t-1">Recover Password
                        </p>
                        <p className="login-text">PASSWORD</p>
                        <div className="text-box1">
                            <input type="password" className="login-input" value={password} onChange={(evt) => { 
                                  setPasswordError('')
                                  setPassword(evt.target.value);}}

                                  onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                      nextKey();        
                                    }
                                  }}/>                        
                        </div>
                        <p className="errorMessage ">{passwordError}</p>
                        <p className="login-text">CONFIRM PASSWORD</p>
                        <div className="text-box1">
                            <input type="password" id="pass-value" className="login-input" value={confirmPassword} onChange={(evt) => { 
                                  setConformPasswordError('')
                                  setConfirmPassword(evt.target.value);}}
                                  onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                      recoverPassword();        
                                    }
                                  }}/>                        
                        </div>
                        <p className="errorMessage ">{conformPasswordError}</p>
                        <button className="button1" onClick={recoverPassword} disabled={Boolean(Loading)}>
                        {Loading?  <><i class="fa fa-spinner fa-spin mr-2"></i><p>Loading</p></> : <p>Update Password</p>}
                        </button>
                    </div>
                </div>
                <div className="col-lg-6 coverimage image4"></div>
            </div>
        </React.Fragment>
    )
}

export default RecoverPassword;